import React, { useEffect, useState, useContext } from 'react';
import CheckField from '../../../../components/CheckField2/CheckField';
import Popover from "../../../../../formik/refactorOut/components/Popper/Popover";
import { popoverLocation } from "../../../../../config/Configuration";
import TextField from '../../../../components/TextField/TextField';
import ErrorBar from '../../../../components/ErrorBar';





function FacilityAdvancedEntry({ props, formik, dbFormSpec }) {
    useEffect(() => {
        if (props.textboxRequired){
        ValidateCustomPhysicianText();}
}, [formik.values.facilityList]);

    function UpsertHashValue(tgtTable, key, value) {
        let tempTable = formik.values[tgtTable];
        tempTable[key] = value;
        formik.setFieldValue(tgtTable, tempTable);
    }

    function ValidateCustomPhysicianText() {
       let checkedBox = (formik.values.facilityList.includes(props.key));
        let validText = (formik.values[props.fieldID]||"").length > 0;

        if ((checkedBox && validText) || (!checkedBox && validText)) {
            UpsertHashValue("CustomPhysicianTextReady", props.key, true);
        }
        else if (!checkedBox && !validText) {
           if (formik.values.CustomPhysicianTextReady) {
                let tempTable = formik.values.CustomPhysicianTextReady;
                delete tempTable[props.key];
                formik.setFieldValue("CustomPhysicianTextReady", tempTable);
            }
        } 
        else if (checkedBox && !validText) {
            UpsertHashValue("CustomPhysicianTextReady", props.key, false);
        }
    }

    let entryType = (props.type || "").toLowerCase().trim();

    switch (entryType) {
        case "textbox":
            return (
                <>< CheckField id={props.key} checkboxType={'facilityTextbox'} formik={formik} className={'advancedFacilityList'} formValue={props.key} checkItemLabel={props.value} trueFormSpec={dbFormSpec} tooltip={props.address} />

                    {formik.errors.CustomPhysicianTextReady &&
                        formik.values.CustomPhysicianTextReady[props.key] === false && 
                        <ErrorBar message={formik.errors.CustomPhysicianTextReady} />}

                    <TextField fieldType={'facility'} formik={formik} fieldId={props.fieldID} cssField={'fname-field'} label={
                        props.label ? props.label : "Please print provider's name."} maxLength={500} requiredVal={true}
                        CustomPhysicianTextRequired={props.textboxRequired}
                        ValidateCustomPhysicianText={ValidateCustomPhysicianText}
                    />
                </>
            );
        case "hr":
            return (<div>  <hr style={{ opacity: 0, marginBottom: 0 }} /><br /></div>);
        case "text": return (<>{props.value}</>);
        case "checkbox": // is the default.
        default: return (<> < CheckField id={props.key} checkboxType={'facility'} formik={formik} className={'advancedFacilityList'} formValue={props.key} checkItemLabel={props.value} trueFormSpec={dbFormSpec} tooltip={props.address} /></>);
    }
}


function FacilityAdvancedList({ formik, dbFormSpec }) {
    const facilityListFilled = dbFormSpec.release.facilities.map((props, index) =>
        <div className='facility-item' key={"facilitySelect" + index} > <FacilityAdvancedEntry props={props} formik={formik} dbFormSpec={dbFormSpec} /> </div>
    );
    return (
        <>
            {facilityListFilled}
        </>
    );
}

export default FacilityAdvancedList;
